import { createSlice } from "@reduxjs/toolkit";
import { createAsyncThunk } from "@reduxjs/toolkit";

import { APP_URL } from "../request/api";
import { request } from "../request/request";

const initialState = {
    columns: [],
    data: {},
    loadingStatus: "idle",
    errors: null
}

export const fetchPreventiveDetails = createAsyncThunk(
    'preventiveDetails/fetchPreventiveDetails',
    async ({token, id}, {rejectWithValue}) => {
        try {
            const customHeaders = {
                Authorization: `Bearer ${token}`
            }

            const response = request(
                `${APP_URL}/surveys/${id}`,
                'GET',
                null,
                customHeaders
            )

            return response
        } catch (error) {
            rejectWithValue(error.status)
        }
    }
)

const preventiveDetails = createSlice({
    name: 'preventiveDetails',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(fetchPreventiveDetails.pending, (state) => {
                state.columns = [];
                state.data = {};
                state.loadingStatus = "loading";
                state.error = null;
            })
            .addCase(fetchPreventiveDetails.fulfilled, (state, action) => {
                state.columns = action.payload.columns;
                state.data = action.payload.data;
                state.loadingStatus = "idle";
                state.error = null;
            })
            .addCase(fetchPreventiveDetails.rejected, (state, action) => {
                state.columns = [];
                state.data = {};
                state.loadingStatus = "error";
                state.error = action.payload;
            })
    }
})

export default preventiveDetails.reducer;